/*
 * @Author: yang_yang 1663724228@qq.com
 * @Date: 2023-03-20 09:23:27
 * @LastEditors: yang_yang 1663724228@qq.com
 * @LastEditTime: 2023-03-30 17:44:34
 * @FilePath: \jyh5\src\assets\i18n\zh\commApp\monthlyHealthReport.js
 * @Description: 健康月报
 */
const month = {
    health_report: "健康報告",
    day: "天",
    month: "月",
    year: "年",
    years: "年度",
    years_health_report: "年度健康報告",
    time: "時間",
    times: "次",
    km: "公里",
    hour: "小時",
    minute: "分鐘",
    circle: "圈",
    step: "步",
    w_step: "萬步",
    score: "分",
    now_month: "本月",
    last_month: "上月",
    keep_measure: "堅持監測身體狀況和適當的運動，",
    can_keep_health: "可以幫助您更好的維持自身健康！",
    overview: "總體概覽",
    initiative_measure: "主動測量次數",
    comm: "正常",
    percent: "占比",
    overPercent: "正常比例超過",
    users: "的用戶",
    allDistance: "運動總里程",
    allDistance2: "運動總距離",
    average_sleep: "平均睡眠時長",
    average_sleep2: "平均睡眠",
    measure_statistics: "測量情況統計",
    now_month_measure: "本月檢測",
    comm_times: "正常次數占比",
    compare_last_month: "比上月",
    heart_rate: "心率",
    electrocardiograph: "心電",
    blood_pressure: "血壓",
    sp: "收縮壓",
    dp: "舒張壓",
    spo: "血氧",
    pressure: "壓力",
    lowest: "最低",
    highest: "最高",
    high: "偏高",
    high2: "高",
    low: "偏低",
    low2: "低",
    light: "輕微",
    middle: "中",
    max_continuous_heart_rate: "最高連續檢測心率",
    sleep_statistics: "睡眠情況統計",
    sport_statistics: "運動統計",
    outdoor_run: "戶外跑步",
    indoor_run: "室內跑步",
    walk: "健走",
    swim: "游泳",
    free_training: "自由訓練",
    sportNum: "運動總次數",
    sportTimes: "運動總時長",
    month_average_step: "本月日均步數",
    share_now: "立即分享",
    average_day_sleep: "日均深睡",
    average_day_light_sleep: "日均淺睡眠",
    average_day_REM: "日均REM",
    average_day_wake: "日均清醒",
    no_data: "暫無數據",

    // 年报
    start: "開啟",
    more_health_body: "你堅守更健康的自己",
    initiative_measure_num: "主動測量次數",
    after_being_busy: "忙碌之餘，",
    remember_measure: "還記得要堅持測量喔！",
    medical_treatment_statistics: "醫療檢測次數統計",
    measurement_analysis: "測量分析",
    comm_num: "正常次數",
    blood_pressure_comm_num: "血壓正常次數",
    keep_measure_blood_pressure:
        "規範、持續測量血壓是預防和治療血壓類疾病的必要作法",
    spo_comm_num: "血氧正常次數",
    comm_precent: "正常次數占比",
    low_bp: "低血壓",
    high_bp: "重度血壓升高",
    low_spo: "低血氧",
    insufficient_spo: "供氧不足",
    know_spo: "了解血氧可以反應身體供氧情況",
    light_pressure_num: "輕微壓力次數",
    high_pressure_num: "高壓力",
    suitable_pressure: "適當的壓力可以提高人的潛能和效率",
    night_sleep: "夜晚合理的睡眠結構，",
    daytime_vitality: "可以讓您白天元氣滿滿～",
    full_sleep: "睡眠充足，超過",
    sleep_analyse: "睡眠情況分析",
    amount_run: "相當於跑了",
    marathon: "個馬拉松",
    now_year_walk: "本年度總步數",
    amount_around_earth: "相當於繞地球走了",
    year_distance: "全年運動距離",
    year_measure: "全年測量",
    index_comm_precent: "健康指標測量正常比例統計",

    month_list: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
    ],
    更新日期: "更新日期",
    生效日期: "生效日期",
    版本记录: "版本記錄",
    确定: "確定",
    隐私协议: "CoDoctor 隱私政策",
    服务条款: "CoDoctor 軟體許可及服務協議",
    ECGAI隐私协议: "CoDoctor ECG-AI 隱私政策",
    ECGAI服务条款: "CoDoctor ECG-AI 軟體許可及服務協議",
};
export { month };



// WEBPACK FOOTER //
// ./src/assets/i18n/tc/commApp/monthlyHealthReport.js